import React, { useState } from 'react'
import usePersistedFilters from '../../hooks/usePersistedFilters'
import PageHeader from '../../shared/PageHeader'
import { FaClipboardList } from 'react-icons/fa6'
import { useTranslation } from 'react-i18next'
import ClaimListTable from '../../components/his/claimgeneration/ClaimListTable'
import moment from 'moment'
import ClaimListFilters from './ClaimListFilters'

function ClaimList() {
  const { t } = useTranslation()
  const { filters: payload, setFilters: setPayload } = usePersistedFilters(
    'claim_list',
    {
      page: 1,
      perPage: 10,
      visit_id: '',
      claim_id: '',
      patient_file_number: '',
      document_id: '',
      start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD')
    },
    { persistPage: true }
  )
  return (
    <div className='main-page-container !overflow-y-auto scrollbar'>
      <PageHeader
        title={t('Claim List')}
        iconSize={20}
        Icon={FaClipboardList}
      ></PageHeader>
      <div>
        <ClaimListTable payload={payload} setPayload={setPayload} />
      </div>
    </div>
  )
}

export default ClaimList
